import React from 'react';
import TimesheetForm from '../components/timesheet/TimesheetForm';

const TimesheetEntry = () => {
  return <TimesheetForm />;
};

export default TimesheetEntry;
